module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-02.e0ddf2de.png";